import { query_s_product_list } from '@/api/mjstock-model';
import { reactive } from 'vue';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import defaultSlotList from '@/components/page-model/slotList';
import { TableColumn } from '@/typing';
import { SearchConfig } from '@/components/FormRender/RemoteModal/typing';

const None = null;
const True = true;
const False = false;

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org

const config: SearchConfig = {
  settings: {
    name: '表单名称',
    labelAlign: 'right',
    layout: 'inline',
  },
  fields: [
    {
      type: 'input',
      name: 'code',
      label: '存货编号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写存货编号',
    },
    {
      type: 'input',
      name: 'name',
      label: '存货名称',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写存货名称',
    },
    {
      type: 'input',
      name: 'gg',
      label: '存货规格',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写存货规格',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    name: null,
    code: null,
    gg: null,
  }),
};
const search_options = {
  is_active: [
    { value: None, name: '全部' },
    { value: True, name: '可用' },
    { value: False, name: '作废' },
  ],
};

const columns: TableColumn[] = [
  {
    title: '序号',
    dataIndex: 'index',
    width: 50,
    fixed: 'left',
    slots: { customRender: 'index' },
  },
  {
    title: '存货编号',
    width: 150,
    dataIndex: 'code',
    fixed: false,
    checked: true,
  },
  {
    title: '存货名称',
    width: 150,
    dataIndex: 'name',
    fixed: false,
    checked: true,
  },

  {
    title: '存货规格',
    width: 150,
    dataIndex: 'gg',
    fixed: false,
    checked: true,
  },
  {
    title: '存货单位',
    width: 150,
    dataIndex: 'dw',
    fixed: false,
    checked: true,
  },
  {
    title: '创建日期',
    width: 150,
    dataIndex: 'create_time',
    fixed: false,
    checked: true,
  },
];

export default () => {
  return {
    searchConfig: config,
    searchConfigOptions: search_options,
    getData: query_s_product_list,
    columns: columns,
    slotList: defaultSlotList,
  };
};
